import { Button, Form, Input } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { BmoModal } from '@/components/BmoModal';

type Props = {
  open: boolean;
  onCancel: () => void;
  onConfirm: (comment: string) => Promise<void>;
};

export function RejectModal({ open, onCancel, onConfirm }: Props) {
  const { t } = useTranslation();
  const [form] = Form.useForm<{ comment: string }>();
  const [confirming, setConfirming] = useState(false);

  const close = () => {
    form.resetFields();
    onCancel();
  };

  const handleOk = async () => {
    let comment: string;
    try {
      ({ comment } = await form.validateFields());
    } catch {
      return;
    }
    setConfirming(true);
    try {
      await onConfirm(comment);
      form.resetFields();
    } catch {
      // Errors are surfaced as toasts by the caller.
    } finally {
      setConfirming(false);
    }
  };

  return (
    <BmoModal
      open={open}
      onCancel={close}
      title={t('approver.reject.title')}
      footer={[
        <Button key="cancel" onClick={close}>
          {t('common.no')}
        </Button>,
        <Button key="reject" type="primary" danger loading={confirming} onClick={handleOk}>
          {t('approver.reject.confirm')}
        </Button>,
      ]}
    >
      <Form<{ comment: string }> form={form} layout="vertical">
        <Form.Item
          name="comment"
          label={t('approver.reject.commentLabel')}
          style={{ marginBottom: 0 }}
          rules={[
            { required: true, message: t('approver.reject.commentRequired') },
            { min: 3, message: t('approver.reject.commentMin') },
          ]}
        >
          <Input.TextArea
            rows={5}
            placeholder={t('approver.reject.commentPlaceholder')}
            style={{ resize: 'none' }}
          />
        </Form.Item>
      </Form>
    </BmoModal>
  );
}
